import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import TeamInfoForm from "../TeamInfoForm";
import { useCurrentProjectMemberStore } from "presentation/stores/use-current-project-member-store";
import { useFilterProjectMemberProjectStore } from "presentation/stores/use-filter-project-member-project-store";
import { useProjectStore } from "presentation/stores/use-project-store";

interface ParamProps {
  onClose?: () => void;
  onOpen?: () => void;
}

const HeaderTeamInfoGrid: React.FC<ParamProps> = (params: ParamProps) => {
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } =
    useFilterProjectMemberProjectStore();
  const { currentProjectMember, setCurrentProjectMember } =
    useCurrentProjectMemberStore();
  const { project } = useProjectStore();

  const isProjectFilled = !!(project?.name?.trim() && project?.startAt && project?.client?.id);

  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    if (!isProjectFilled) return;
    setShowModal(true);
    params?.onOpen?.(); // chama o callback se existir
  };

  const handleCloseModal = () => {
    setCurrentProjectMember(undefined);
    setShowModal(false);
    params?.onClose?.(); // idem para fechar
  };

  const clearFilter = () => {
    resetFilters();
    setGlobalFilterValue("");
    setFilters({
      "employee.name": { value: "", matchMode: "contains" },
      projectRole: { value: "", matchMode: "contains" },
      status: { value: "", matchMode: "contains" },
    });
  };

  return (
    <div className="flex justify-content-between">
      <Dialog
        header="Adicionar colaborador"
        visible={showModal}
        style={{ width: "50vw" }}
        onHide={handleCloseModal}
      >
        <TeamInfoForm isDisable={false} onClose={handleCloseModal} />
      </Dialog>

      <div></div>

      <div style={{ display: "flex" }}>
        <Button
          type="button"
          icon="pi pi-plus"
          label="Adicionar Colaborador"
          outlined
          onClick={handleOpenModal}
          disabled={!isProjectFilled}
          style={{
            backgroundColor: isProjectFilled ? "#2196f3" : "#e0e0e0",
            color: isProjectFilled ? "white" : "#9e9e9e",
            borderRadius: "8px",
            border: "none",
            cursor: isProjectFilled ? "pointer" : "not-allowed"
          }}
        />
        <div style={{ width: "10px" }}></div>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
        <div style={{ width: "10px" }}></div>
      </div>
    </div>
  );
};
export default HeaderTeamInfoGrid;
